module.exports = __webpack_public_path__ + "img/Ganvié.bdc7b938.jpg";